import { SubscriptionDetails } from "features/types";
import { useMemo } from "react";

const useSubscriptionOperable = (
  selectedSubscription: SubscriptionDetails | null
) => {
  const subscriptionOperative = useMemo(() => {
    if (!selectedSubscription) return false;
    if (!selectedSubscription.operative) return false;
    const ticketApprovalEnabled =
      selectedSubscription.planPackage.ticketApprovalEnabled;
    const userSelfRequestEnabled =
      selectedSubscription.planPackage.userSelfRequestEnabled;
    if (ticketApprovalEnabled && !userSelfRequestEnabled) return false;

    return true;
  }, [selectedSubscription]);
  return subscriptionOperative;
};

export default useSubscriptionOperable;
